import * as angular from 'angular';

import controller from './table-grid-controller';

function tableGridDirective() {
  return {
    scope: {
      tableID: '@id',
      dataset: '<',
      view: '<?setView',
      onSelectColumn: '&?',
      selected: '@',
      viewer: '<',
      capacityOverride: '<',
      onAction: '&',
    },
    controller,
    template: `
      <div
        class="editor-module editor-multi mode-object editor-table"
        ng-show="ctrl.showTable()"
        ng-class="{'is-report-mode': ctrl.isReportMode() || ctrl.isBuilderMode(), 'is-design-mode': ctrl.isDesignerMode(), 'is-linkable': ctrl.isLinkable(), 'is-phantom-mode': ctrl.isPhantomMode()}">
        <div class="chart-content" ng-class="{'content-exceeds-limit': ctrl.exceedsRowLimit()}">
          <!-- Component Header Begins -->
          <div class="chart-header" ng-if="ctrl.isReportMode() || ctrl.isBuilderMode()">
            <span class="chart-title">{{ctrl.queryName()}}</span>

            <div class="new-viz-actions">
              <!-- Filter Begins -->
              <div ng-if="!ctrl.isPhantomMode()" class="table-filter-module" ng-class="{'with-lightbox': !ctrl.viewer, 'with-focus': ctrl.isFilterFocus}">
                <div class="filter-container">
                  <input
                    type="text"
                    class="filter-field"
                    placeholder="Filter..."
                    ng-model="ctrl.filterQuery"
                    ng-model-options="{ debounce: 250 }"
                    ng-change="ctrl.applyFilter(ctrl.filterQuery)"
                    ng-focus="ctrl.selectAllInputText($event)"
                    ng-blur="ctrl.removeFilterFocus()"/>
                </div>
                <button
                  class="filter-apply-btn"
                  uib-tooltip="{{ ctrl.filterQuery.length ? 'Clear Filter' : 'Filter Table' }}"
                  tooltip-placement="{{ ctrl.viewer === 'whiteLabel' ? 'left' : 'top' }}">
                  <svg-icon type="'filter'" ng-if="!ctrl.filterQuery.length" ng-click="ctrl.selectFilterInput($event)"></svg-icon>
                  <svg-icon type="'cancel-find'" ng-if="ctrl.filterQuery.length && ctrl.isFilterFocus" ng-mousedown="ctrl.clearFilterInput($event)"></svg-icon>
                  <svg-icon type="'clear-filter'" ng-if="ctrl.filterQuery.length && !ctrl.isFilterFocus" ng-mousedown="ctrl.clearFilterInput($event)"></svg-icon>
                </button>
              </div>
              <!-- @Filter Ends -->

              <div class="new-viz-actions__section" ng-if="ctrl.viewer !== 'whiteLabel'">
                <button
                  class="new-viz-action hide-2"
                  ng-if="ctrl.reportVizURL()"
                  ng-show="isClipboardEnabled"
                  uib-tooltip="Copy Link to Table"
                  copy-to-clipboard
                  clipboard-text="ctrl.reportVizURL()"
                  clipboard-success="ctrl.copySuccess()"
                  clipboard-enabled="isClipboardEnabled">
                  <svg-icon type="'copy-link'"></svg-icon>
                </button>

                <button class="new-viz-action">
                  <kebab-menu targetable="true">
                    <li menu-item="exp" ng-click="ctrl.linkTo($event, 'query')" ng-href="{{ ctrl.reportDataURL() }}" ng-if="!ctrl.viewer">View Query <span class="mode-show-embed-inline">in Mode</span></li>
                    <li menu-item="exp" ng-click="ctrl.linkTo($event, 'data')" ng-href="{{ ctrl.reportDataURL() }}">View Query Results <span class="mode-show-embed-inline">in Mode</span></li>
                  </kebab-menu>
                </button>
              </div>

              <div class="new-viz-actions__section" ng-if="!ctrl.viewer">
                <span class="divider"></span>

                <a
                  class="new-viz-action"
                  ng-href="{{ ctrl.reportVizURL() }}"
                  ng-click="ctrl.linkTo($event, 'lightbox')">
                  <svg-icon class="mode-hide-embed" type="'toggle-expanded-view'" uib-tooltip="Expand"></svg-icon>
                  <svg-icon class="mode-show-embed-flex-inline" type="'toggle-expanded-view'" uib-tooltip="Expand in Mode" tooltip-placement="left"></svg-icon>
                </a>
              </div>
            </div>
          </div>
          <!-- Component Header Ends -->

          <!-- Table Container Begins -->
          <div ng-show="ctrl.dataState() === 'succeeded'" class="js-table-container mode-table-grid"></div>
          <!-- @Table Container Ends -->

          <!-- Intermediary Messages Begin -->
          <div ng-if="ctrl.dataState() === 'oversized'" class="error-message" >
            <i class="icon-warning-small error-icon"></i>
            <div class="message">
              This query is too large to show in browser
              <a
                ng-click="ctrl.linkTo($event, 'data')"
                ng-href="{{ ctrl.reportDataURL() }}"
                target="_blank"
                rel="noopener"
                class="sub-message">
                Access the data
              </a>
            </div>
          </div>
          <div ng-show="ctrl.exceedsRowLimit()" class="more-text">
            This table only shows the first {{ ctrl.rowLimit() | number }} rows. <span ng-if="ctrl.viewer !== 'whiteLabel'">View complete results in
            <a ng-click="ctrl.linkTo($event, 'data')" ng-href="{{ ctrl.reportDataURL() }}" target="_blank" rel="noopener">Report Details</a>.<span>
          </div>
          <div ng-if="ctrl.dataState() === 'failed'" class="error-message">
            <img ng-src="{{ ctrl.errorImage() }}" class="error-icon">
            <div class="message">Looks like something went wrong with your query</div>
            <a href="#" ng-click="ctrl.linkTo($event, 'data')" ng-href="{{ ctrl.reportDataURL() }}" target="_blank" rel="noopener" class="sub-message">
              Take a look at the issue
            </a>
          </div>
          <div ng-if="ctrl.dataState() === 'cancelled'" class="error-message">
            <i class="icon-warning-small error-icon"></i>
            <div class="message">This query was canceled</div>
            <div class="sub-message"></div>
          </div>
          <div ng-if="ctrl.dataState() === 'running' && ctrl.dataAvailable()" class="error-message">
            <i class="icon-warning-small error-icon"></i>
            <div class="message">This query is still running. Refresh the page to see the results.</div>
            <div class="sub-message"></div>
          </div>
          <div ng-if="ctrl.dataState() === 'empty'" class="error-message">
            <div class="message">No rows returned</div>
          </div>
          <!-- @Intermediary Messages End -->
        </div>
      </div>
    `,
    controllerAs: 'ctrl',
    bindToController: true,
    link: (scope, element, attrs, ctrl) => {
      element.get(0).addEventListener('click', handleClickCaptureEvent, true);

      function handleClickCaptureEvent(evt) {
        const $header = angular.element(evt.target).closest('.js-col-header');
        const validHeaderIsUnselected = $header.length > 0 && !$header.hasClass('is-selected-col');

        if (validHeaderIsUnselected) {
          ctrl.trackColumnSelectStart();
        }
      }
    },
  };
}

export { tableGridDirective };
